export let CHANGE_PAGE ='header/CHANGE_PAGE';
export let MOUSE_LEAVE = 'header/MOUSE_LEAVE';
export let MOUSE_ENTER = 'header/MOUSE_ENTER';
export let CHANGE_LIST = 'header/CHANGE_LIST';
export const SEARCH_FOCUS= 'header/SEARCH_FOCUS';
export const SEARCH_BLUR= 'header/SEARCH_BLUR';